/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Info/DateRange
 * @desc Show edit experimentWorkflow startedAt and endedAt
 */

import { ExperimentWorkflowInfoEndedAt } from 'labstep-web/components/ExperimentWorkflow/Info/EndedAt';
import { ExperimentWorkflowInfoStartedAt } from 'labstep-web/components/ExperimentWorkflow/Info/StartedAt';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { ExperimentWorkflowInfoDateRangeProps } from './types';

export const ExperimentWorkflowInfoDateRange: React.FC<
  ExperimentWorkflowInfoDateRangeProps
> = ({ experimentWorkflow }) => (
  <Flex wrap className={styles.container}>
    <div>
      <Icon name="calendar alternate outline" />
    </div>
    <ExperimentWorkflowInfoStartedAt
      experimentWorkflow={experimentWorkflow}
    />
    <span>&nbsp;-&nbsp;</span>
    <ExperimentWorkflowInfoEndedAt
      experimentWorkflow={experimentWorkflow}
    />
  </Flex>
);
